export default "__VITE_ASSET__D3eS2SEu__"